import Image from 'next/image';
import type { UiLogoProps } from './UiLogo.types';
import { LOGO_MAP } from './UiLogo.constants';
import { cn } from '@/lib/tailwind';

function UiLogo({ variant = 'emblem', className, alt = 'Haustein Immobilien', eager }: UiLogoProps) {
    const src = LOGO_MAP[variant];

    return (
        <div className={cn('relative w-16 h-full', className)}>
            <Image
                src={src}
                alt={alt}
                className="object-contain"
                sizes="64px"
                loading={eager ? 'eager' : undefined}
                fill
            />
        </div>
    );
}
export default UiLogo;
